import React from 'react';
import Slide from '@material-ui/core/Slide';

const TransitionSlide = React.forwardRef((props, ref) => <Slide direction="up" mountOnEnter unmountOnExit ref={ref} {...props} />);

// eslint-disable-next-line
export const TransitionSlideNoUnmount = React.forwardRef((props, ref) => <Slide direction="up" mountOnEnter ref={ref} {...props} />);

export default TransitionSlide;
